import RatingWrapper from '@components/RatingWrapper/RatingWrapper';
import Search from '@components/Search/Search';
import { PagesProvider } from 'context/PagesContext';
import getConfig from 'next/config';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';
import getQuerySSR from 'utils/getQuerySSR';

const { publicRuntimeConfig } = getConfig();

export async function getServerSideProps(params) {
  const page = getQuerySSR(params.query?.page);
  const pageParam = page ? `page=${encodeURIComponent(page)}` : '';
  const region = getQuerySSR(params.query?.region);
  const regionParam = region ? `region=${encodeURIComponent(region)}` : '';
  const city = getQuerySSR(params.query?.city);
  const cityParam = city ? `city=${encodeURIComponent(city)}` : '';
  const name = getQuerySSR(params.query?.name);
  const nameParam = name ? `name=${encodeURIComponent(name)}` : '';
  const queryArray = [pageParam, regionParam, cityParam, nameParam]
    .filter((i) => i !== '')
    .join('&')
    .trim();
  if (region || city || name) {
    return {
      redirect: {
        destination: `/?${queryArray}`,
        permanent: false,
      },
    };
  }

  const res = await fetch(
    `${publicRuntimeConfig.INTERNAL_API_URL}/regions/${params.query.regionId}?${pageParam}`,
  );
  if (!res.ok) {
    return {
      notFound: true,
    };
  }
  const resp = await res.json();

  return {
    props: { resp, page: page || 1 },
  };
}

const RegionId = ({ resp, page }) => {
  const router = useRouter();
  const canonicalUrl = `${publicRuntimeConfig.BASE_URL}${router.asPath}`;
  return (
    <>
      <Head>
        <link rel="canonical" href={canonicalUrl} />
      </Head>
      <PagesProvider value={{ ...(typeof resp === 'object' ? resp : {}), page: +page }}>
        <Search />
        <RatingWrapper />
      </PagesProvider>
    </>
  );
};

export default RegionId;
